






























import Vue from "vue";
import Component from "vue-class-component";
import { mask } from 'vue-the-mask';
import ChevronDoubleRightIcon from "vue-material-design-icons/ChevronDoubleRight.vue";

@Component({
    components: { ChevronDoubleRightIcon }
})
export default class Protecao extends Vue {
    public regras = [(v: string) => (v && v.length >= 6) || 'Placa não encontrada'];

    public onClick () {
       this.$router.push({
            name: 'placaform'
        });
    }
}
